import { render, staticRenderFns } from "./CampaignPerformance.vue?vue&type=template&id=8656f0c6&"
import script from "./CampaignPerformance.vue?vue&type=script&lang=js&"
export * from "./CampaignPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports